export default __webpack_public_path__ + "static/media/cert-4.7dc6db08.webp";